const getRemoveMessage = (name: string): string => {

    return `Are you sure you want to remove url '${name}'?`;
};

export { getRemoveMessage };
